import * as React from "react";
import styles from "./styles";
import Button from "@material-ui/core/Button";
import ChatSubmit from "../ChatSubmit";
import { withStyles } from "@material-ui/styles";

const extraStyles = (theme) => ({
  seeMore: {
    color: theme.palette.primary.main
  }
})
class BubbleGroup extends React.Component {
  constructor(props) {
    super(props);
    // if the message group isnt cy then hide any excess above 3 items
    let spliceMessages = [...this.props.messages];
    spliceMessages.splice(0, 3);
    this.state = {
      collapseNodes:
        this.props.messages.length > 3 && this.props.messages[0].userId !== 1
          ? [...spliceMessages]
          : [],
    };
  }
  // take an array of messages that should uncollsapse

  updateCollapse = (collapseNodes) => {
    this.setState({ collapseNodes });
  };

  render() {
    const { messages } = this.props;
    const {
      bubbleStyles,
      prevMessages,
      chatBubble,
      treeStep,
      createdTicket,
      errorMessage,
      submissionError,
      onClick,
      creatingTicket,
      classes
    } = this.props;
    const { collapseNodes } = this.state;
    const userId = messages[0].userId;

    const ChatBubble = chatBubble;

    const messageNodes = messages.map((message, i) => {
      return message.componentType === "bubble" ? (
        <ChatBubble
          prevMessages={prevMessages}
          groupCollapse={!collapseNodes.includes(message)}
          creatingTicket={creatingTicket}
          createdTicket={createdTicket}
          key={i}
          message={message}
          bubbleStyles={bubbleStyles}
          onClick={onClick}
          treeStep={treeStep}
        />
      ) : message.componentType === "select" ? (
        <ChatSubmit
          submissionError={submissionError}
          createdTicket={createdTicket}
          creatingTicket={creatingTicket}
          errorMessage={errorMessage}
          key={i}
          message={message}
          onClick={onClick}
        />
      ) : (
        <ChatBubble
          groupCollapse={!collapseNodes.includes(message)}
          prevMessages={prevMessages}
          creatingTicket={creatingTicket}
          createdTicket={createdTicket}
          key={i}
          message={message}
          bubbleStyles={bubbleStyles}
          onClick={onClick}
          treeStep={treeStep}
        />
      );
    });
    let finishMessages = [...messageNodes];
    // use this for expanding buttons
    const prevBubble = [...messageNodes]
      .splice(0, 3)
      .map((node) => node.props.message);

    const isPrevBubble = prevBubble.every((elem) =>
      prevMessages.includes(elem)
    );

    //  dont add expand button for cy
    if (messageNodes.length > 3 && !isPrevBubble && userId !== 1) {
      const groupedMessages = (
        <div
          key="button"
          style={{
            overflow: "auto",
            display: "flex",
            margin: "4px 4px",
            justifyContent: "flex-end",
          }}
        >
          {collapseNodes.length !== 0 && (
            <Button
              disableRipple
              variant="text"
              onClick={() => this.updateCollapse([])}
              className={classes.seeMore}
            >
              Show more +
            </Button>
          )}
        </div>
      );
      finishMessages = [...finishMessages, groupedMessages];
    }

    return <div style={styles.chatbubbleWrapper}>{finishMessages}</div>;
  }
};

export default withStyles(extraStyles)(BubbleGroup);


// WEBPACK FOOTER //
// ./src/components/HelpWidget/components/BubbleGroup/index.jsx